import { Controller } from "@hotwired/stimulus"

export default class OauthController extends Controller {
  google(event) {
    event.preventDefault()

    this.submitPost(event.currentTarget.href)
  }

  microsoft(event) {
    event.preventDefault()

    this.submitPost(event.currentTarget.href)
  }

  submitPost(url) {
    const form = document.createElement("form")

    form.method = "POST"
    form.action = url
    form.dataset.turbo = false

    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]'
    )?.content

    if (csrfToken) {
      const csrfInput = document.createElement("input")

      csrfInput.type = "hidden"
      csrfInput.name = "authenticity_token"
      csrfInput.value = csrfToken

      form.appendChild(csrfInput)
    }

    document.body.appendChild(form)
    form.requestSubmit()
  }
}
